// extracted by mini-css-extract-plugin
export default {"note":"NotesComp_note__Ch3rL"};